import { Controller } from "@hotwired/stimulus"

// Online sessions use the in-app room, so the place field stays hidden.
// In person asks for a room or address. Phone needs no place.
export default class extends Controller {
  static targets = ["format", "field", "label", "input"]
  static values = { labels: Object, placeholders: Object, defaults: Object }

  connect() {
    this.previousDefault = this.defaultsValue[this.currentFormat()] || ""
    this.apply(false)
  }

  change() {
    this.apply(true)
  }

  currentFormat() {
    return this.hasFormatTarget ? this.formatTarget.value : ""
  }

  apply(fillDefault) {
    const format = this.currentFormat()
    const hide = format === "phone" || format === "online"
    if (this.hasFieldTarget) this.fieldTarget.hidden = hide
    if (hide) return
    if (this.hasLabelTarget && this.labelsValue[format]) this.labelTarget.textContent = this.labelsValue[format]
    if (this.hasInputTarget) {
      this.inputTarget.placeholder = this.placeholdersValue[format] || ""
      const nextDefault = this.defaultsValue[format] || ""
      const current = this.inputTarget.value.trim()
      if (fillDefault && (current === "" || current === this.previousDefault)) this.inputTarget.value = nextDefault
      this.previousDefault = nextDefault
    }
  }
}
